import React, { Component } from 'react'
import {FilterDropdownStyle} from '../styles'
import {ArrowDrop, Checkbox} from '.'

export default class FilterDropdown extends Component {
  state = {
    open: false,
    filters: [],
    category: ''
  }

  handlerClick = () => {
    this.props.toggleOpen(this.props.id)
  }

  getFilters = (checkbox) => {
    let nFilters = this.state.filters
    if (checkbox.checked) nFilters.push(checkbox.value)
    else nFilters = nFilters.filter( filter => filter !== checkbox.value )

    this.setState({ filters: nFilters }, () => {
      this.props.callbackFilters(this.state.filters, this.props.label)
    })
  }

  render () {
    const { isOpen, label, lists, dark } = this.props
    const { open } = this.state

    return (
      <div className={`${FilterDropdownStyle(isOpen, dark)} dropdown`}>
        <div className="dropdown-label" onClick={this.handlerClick}> { label } <ArrowDrop width={10} height={10} /> </div>
        <div className="dropdown-list">
          {
            lists.map((item, i) => (
              <Checkbox key={i} onCallback={this.getFilters} name={`${item.name}[${label}]`} id={`${label}[${item.name}]`} value={item.name} checked={item.checked}> {item.name} </Checkbox>
            ))
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FilterDropdown.js